export default {
    projects: [],
    errors: {},
    project: null,
    stats : null
};


/** WEBPACK FOOTER **
 ** ./src/container/ProjectContainer/initialState.js
 **/